module.exports = __webpack_public_path__ + "static/media/gregory_english_us.aaa2d515.mp3";